import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import logo from "../Assets/carrerup_allInOne_cover_NoBg.png";
import "../PrivacyPolicy/PrivacyPolicy.css";

const UPDATED_AT = "5 août 2026";

export default function ChildSafety() {
  return (
    <main className="privacy-page">
      <Helmet>
        <title>Normes de sécurité des enfants | CarrerUp</title>
        <meta
          name="description"
          content="Normes CarrerUp contre les abus et l’exploitation sexuelle des enfants (CSAE/CSAM)."
        />
      </Helmet>

      <header className="privacy-header">
        <Link to="/" aria-label="Retour à l’accueil CarrerUp">
          <img src={logo} alt="CarrerUp" />
        </Link>
        <Link className="privacy-home-link" to="/">
          Retour à l’accueil
        </Link>
      </header>

      <article className="privacy-card">
        <div className="privacy-intro">
          <span className="privacy-kicker">Protection des mineurs</span>
          <h1>Normes liées à la sécurité des enfants</h1>
          <p>
            CarrerUp applique une politique de tolérance zéro envers toute forme
            d’abus ou d’exploitation sexuelle des enfants et envers tout contenu
            mettant un mineur en danger.
          </p>
          <p className="privacy-date">Dernière mise à jour : {UPDATED_AT}</p>
        </div>

        <nav className="privacy-summary" aria-label="Sommaire">
          <a href="#prohibited">Contenus interdits</a>
          <a href="#report">Signaler</a>
          <a href="#action">Mesures appliquées</a>
          <a href="#contact">Contact sécurité</a>
        </nav>

        <section>
          <h2>1. Notre engagement</h2>
          <p>
            Ces normes s’appliquent au site carrerup.com, à l’application mobile
            CarrerUp et à tous les comptes, profils, publications, commentaires,
            messages, images, vidéos et fichiers transmis sur la plateforme.
            CarrerUp interdit strictement les abus et l’exploitation sexuelle des
            enfants (CSAE) ainsi que les contenus montrant des abus sexuels sur
            mineurs (CSAM).
          </p>
        </section>

        <section id="prohibited">
          <h2>2. Comportements et contenus interdits</h2>
          <p>Il est notamment interdit de créer, publier, envoyer ou solliciter :</p>
          <ul>
            <li>tout contenu sexuel représentant ou impliquant un mineur ;</li>
            <li>
              toute tentative de manipulation ou de mise en confiance d’un mineur
              à des fins sexuelles (« grooming ») ;
            </li>
            <li>
              la sollicitation, l’échange ou la menace de diffusion d’images
              intimes d’un mineur, y compris la sextorsion ;
            </li>
            <li>
              la sexualisation, l’exploitation, le trafic ou la mise en danger
              d’un enfant ;
            </li>
            <li>
              tout lien, instruction ou moyen facilitant l’accès à de tels
              contenus ou comportements ;
            </li>
            <li>
              toute intimidation, menace ou prise de contact prédatrice visant un
              mineur.
            </li>
          </ul>
        </section>

        <section id="report">
          <h2>3. Signaler un problème</h2>
          <p>
            Toute personne peut signaler un contenu, un comportement ou un compte
            susceptible de mettre un enfant en danger. Écrivez immédiatement à{" "}
            <a href="mailto:support@carrerup.com?subject=Signalement%20urgent%20-%20sécurité%20d’un%20mineur">
              support@carrerup.com
            </a>{" "}
            en indiquant, si possible, le nom d’utilisateur concerné, le lien ou
            l’identifiant du contenu et une description factuelle. Ne joignez pas
            et ne transférez pas de contenu illégal dans votre signalement.
          </p>
          <p>
            Si un enfant se trouve en danger immédiat, contactez sans délai les
            services d’urgence ou les autorités compétentes de votre pays.
          </p>
        </section>

        <section id="action">
          <h2>4. Traitement des signalements</h2>
          <p>
            CarrerUp examine en priorité les signalements relatifs à la sécurité
            des enfants. Lorsque nous avons connaissance d’un contenu ou d’un
            comportement interdit, nous pouvons notamment :
          </p>
          <ul>
            <li>retirer ou rendre inaccessible le contenu concerné ;</li>
            <li>suspendre ou supprimer le compte responsable ;</li>
            <li>préserver les informations nécessaires à l’enquête ;</li>
            <li>empêcher de nouvelles interactions présentant un risque ;</li>
            <li>
              signaler les cas confirmés aux autorités ou organismes compétents,
              notamment au NCMEC lorsque la législation applicable l’exige.
            </li>
          </ul>
        </section>

        <section>
          <h2>5. Respect des lois</h2>
          <p>
            CarrerUp s’engage à respecter les lois et réglementations applicables
            à la protection des enfants. Nous coopérons avec les autorités
            compétentes lorsque cela est légalement requis et répondons aux
            demandes valides relatives aux enquêtes de sécurité.
          </p>
        </section>

        <section>
          <h2>6. Responsabilité des utilisateurs</h2>
          <p>
            Les utilisateurs doivent adopter un comportement professionnel,
            protéger leurs informations personnelles et signaler immédiatement
            toute interaction préoccupante. Il est interdit de tenter d’enquêter
            soi-même, de télécharger, de conserver ou de repartager un contenu
            présumé illégal.
          </p>
        </section>

        <section id="contact" className="privacy-contact">
          <h2>7. Point de contact pour la sécurité des enfants</h2>
          <p>
            Le point de contact CarrerUp chargé de recevoir les alertes relatives
            aux abus et à l’exploitation sexuelle des enfants est joignable à :
          </p>
          <a href="mailto:support@carrerup.com?subject=Sécurité%20des%20enfants">
            support@carrerup.com
          </a>
        </section>

        <section>
          <h2>8. Documents associés</h2>
          <p>
            Consultez également notre{" "}
            <Link to="/privacy-policy">politique de confidentialité</Link>.
          </p>
        </section>
      </article>
    </main>
  );
}
